import { createRouter, createWebHistory } from "vue-router"
import VueRouteMiddleware from "vue-route-middleware"

import auth from '@/middleware/auth'

const routes = [
	{
		path: "/",
		name: "index",
		redirect: "main",
		meta: {
			middleware: [auth],
		},
	},
	// {
	// 	path: "/login",
	// 	name: "login",
	// 	component: () => import("@/views/Pages/Login.vue"),
	// 	meta: {
	// 		middleware: [auth],
	// 	},
	// },
	{
		path: "/form/internal",
		name: "leadForm_internal",
		component: () => import("@/views/Pages/LeadForm_Internal.vue"),
	},
	{
		path: "/form/client-proposals/:unique_key/:access_key",
		name: "clientProposal",
		component: () => import("@/views/Pages/Proposals/ClientProposal.vue"),
		props: true,
	},
	{
		path: "/form/penetration-testing",
		name: "leadForm_pentest",
		component: () => import("@/views/Pages/LeadForm_Pentest.vue"),
	},
	{
		path: "/validation",
		name: "validation",
		component: () => import("@/views/Validation.vue"),
	},
	{
		path: "/main",
		name: "main",
		component: () => import("@/views/Main.vue"),
		meta: {
			middleware: [auth],
		},
		redirect: "leads",
		children: [
			{
				path: "/dashboard",
				name: "dashboard",
				component: () => import("@/views/Pages/Dashboard.vue"),
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: "/leads",
				name: "leads",
				component: () => import("@/views/Pages/Leads/Dashboard.vue"),
				meta: {
					requiresAuth: true,
				},
				children: [
					{
						path: ":id",
						name: "leads-view",
						component: () => import("@/components/Leads/Sidebar.vue"),
						props: true,
						meta: {
							requiresAuth: true,
						},
					},
				],
			},
			{
				path: "/proposals",
				name: "proposals",
				component: () => import("@/views/Pages/Proposals/Dashboard.vue"),
				meta: {
					requiresAuth: true,
				},
				// children: [
				// 	{
				// 		path: ":id",
				// 		name: "leads-view",
				// 		component: () => import("@/components/Leads/Sidebar.vue"),
				// 		props: true,
				// 		meta: {
				// 			requiresAuth: true,
				// 		},
				// 	},
				// ],
			},
			{
				path: "/product-pricing",
				name: "product_pricing",
				component: () => import("@/views/Pages/ProductPricing/Dashboard.vue"),
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: "/content-library",
				name: "content-library",
				component: () => import("@/views/Pages/ContentLibrary/Dashboard.vue"),
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: "/content-library/blocks",
				name: "content_library_blocks",
				component: () => import("@/views/Pages/ContentLibrary/BlockDashboard.vue"),
				// children: [
				// 	{
				// 		path: ":id",
				// 		name: "control-view",
				// 		component: () => import("@/components/catalogue/controls/Sidebar.vue"),
				// 		props: true,
				// 		meta: {
				// 			requiresAuth: true,
				// 		},
				// 	},
				// ],
			},
			{
				path: "/blocks/:id",
				name: "block-tab-view",
				component: () => import("@/views/Pages/ContentLibrary/BlockView.vue"),
				props: true,
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: "/proposals/:id",
				name: "proposal-view",
				component: () => import("@/views/Pages/Proposals/ProposalView.vue"),
				props: true,
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: "/content-library/testimonials",
				name: "content_library_testimonials",
				component: () => import("@/views/Pages/ContentLibrary/TestimonialDashboard.vue"),
				children: [
					{
						path: ":id",
						name: "testimonial-view",
						component: () => import("@/components/ContentLibrary/TestimonialDetailedView.vue"),
						props: true,
						meta: {
							requiresAuth: true,
						},
					},
				],
			},
			{
				path: "/testimonials/:id",
				name: "testimonial-tab-view",
				component: () => import("@/views/Pages/ContentLibrary/TestimonialView.vue"),
				props: true,
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: "/maintenance-settings/dashboard",
				name: "maintenanceSettings_Dashboard",
				component: () => import("@/views/Pages/MaintenanceSettings/Dashboard.vue"),
				meta: {
					requiresAuth: true,
				},
			},
		],
	},
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
});

router.beforeEach(VueRouteMiddleware ({auth}))

export default router;
